import {
  addHours,
  setHours,
  setMinutes,
  startOfDay,
  Interval,
  setSeconds,
  setMilliseconds,
  isSameHour,
  isSameMinute,
  format,
} from "date-fns";
import { datesInInterval } from "./interval";

export const MINUTES_IN_ONE_DAY = 24 * 60;
export const MINUTES_IN_ONE_HOUR = 60;

const TIME_HOUR_FORMAT = "HH";
const TIME_MINUTE_FORMAT = "mm";
export const TIME_FORMAT = `${TIME_HOUR_FORMAT}${TIME_MINUTE_FORMAT}`;

/**
 * Creates a new [Date] with the given time
 */
function newTime(hours: number, minutes: number): Date {
  let date = new Date();

  date = setHours(date, hours);
  date = setMinutes(date, minutes);
  date = setSeconds(date, 0);
  date = setMilliseconds(date, 0);

  return date;
}

export function setSameTime(date: Date, toTime: Date) {
  date = setHours(date, toTime.getHours());
  date = setMinutes(date, toTime.getMinutes());
  date = setSeconds(date, 0);
  date = setMilliseconds(date, 0);

  return date;
}

export function isSameTime(dateLeft: Date, dateRight: Date) {
  return isSameHour(dateLeft, dateRight) && isSameMinute(dateLeft, dateRight);
}

export function parseTime(time: string): Date {
  const [hours, minutes] = getTime(time);

  return newTime(Number(hours), Number(minutes));
}

export function toTime(date: Date): string {
  return format(date, TIME_FORMAT);
}

function getTime(time: string): [string, string] {
  const hours = time.substring(0, 2);
  const minutes = time.substring(2);

  return [hours, minutes];
}

// HHMM and nothing else. The availability API, the picker and the quote payload
// all speak this one form, so a value that merely begins with four digits is not
// a time we can use: it survives every parser downstream and is refused only
// when the booking is written, long after the customer has paid.
const TIME_PATTERN = /^([01]\d|2[0-3])[0-5]\d$/;

export function isValidTime(time: string): boolean {
  return TIME_PATTERN.test(time);
}

export const setTime = (
  date: Date,
  hours: number,
  minutes = 0,
  seconds = 0,
  milliseconds = 0
) => {
  return setMilliseconds(
    setSeconds(setMinutes(setHours(date, hours), minutes), seconds),
    milliseconds
  );
};

const eachHourOfInterval = (interval: Interval, step = 1) =>
  datesInInterval(interval, addHours, step);

export const getHoursInDay = (date: Date = new Date()) =>
  eachHourOfInterval({
    start: setTime(startOfDay(date), 0),
    end: setTime(startOfDay(date), 24),
  });
